import PropTypes from 'prop-types';
import { createContext, useContext, useState, useSyncExternalStore } from 'react';

// O hover do canvas fica fora do CheckoutBuilderContext e fora do estado do React de propósito:
// mouseenter/mouseleave disparam a cada bloco cruzado (inclusive ao rolar com o mouse parado), e
// como valor de contexto cada evento re-renderizava o builder e o mockup inteiros. Com o store,
// cada bloco assina só o booleano "estou em hover" e apenas os dois que trocam re-renderizam.
function createHoverStore() {
  let hovered = null;
  const listeners = new Set();

  return {
    getHovered: () => hovered,
    setHovered: (next) => {
      hovered = next;
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}

const CheckoutBuilderHoverContext = createContext(createHoverStore());

const CheckoutBuilderHoverProvider = ({ children }) => {
  const [store] = useState(createHoverStore);

  return (
    <CheckoutBuilderHoverContext.Provider value={store}>
      {children}
    </CheckoutBuilderHoverContext.Provider>
  );
};

CheckoutBuilderHoverProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// O selector precisa devolver primitivo: objeto novo a cada leitura faria o useSyncExternalStore
// re-renderizar em toda notificação.
const useHoveredSelector = (selector) => {
  const store = useContext(CheckoutBuilderHoverContext);

  return useSyncExternalStore(store.subscribe, () => selector(store.getHovered()));
};

const useSetHovered = () => useContext(CheckoutBuilderHoverContext).setHovered;

export { CheckoutBuilderHoverProvider, useHoveredSelector, useSetHovered };
